import { Component, Prop, Vue } from 'vue-property-decorator';
import { Logger } from 'fsts';
import { Contact } from '@/shared/model/contact';
import { namespace } from 'vuex-class';

const logger = new Logger('deactivate-dialog');
const contactModule = namespace('contact');
const authModule = namespace('auth');

@Component({
  name: 'deactivate-dialog',
  components: {},
})
export default class DeactivateDialog extends Vue {
  @contactModule.Action('deactivateContact')
  private actionDeactivateContact!: any;

  @authModule.Action('loadAzureUserId')
  private actionLoadAzureUserId!: any;
  @authModule.Action('deactivateUserOnAzure')
  private actionDeactivateUserOnAzure!: any;
  @authModule.Action('activateUserOnAzure')
  private actionActivateUserOnAzure!: any;

  @Prop({ default: false })
  private dialog!: boolean;

  @Prop()
  private contactModel!: Contact;

  isSaving = false;
  contactAzureId: string | null = null;
  async clickDeactivate(): Promise<void> {
    logger.log('deactivate-user');

    this.isSaving = true;

    const userId = await this.actionLoadAzureUserId(this.contactModel.email)
      .then(async (result: any) => {
        const azureUserId = result;
        this.contactAzureId = azureUserId;

        const payload = {
          email: this.contactModel.email,
          azureUserId: this.contactAzureId,
        };

        // (AD-0) return logic to `de- + activate` user in `Entra`  // (AD-72) (discussed with Chaslau) Temporary comment Azure activate functionality (just update database) (2023-06)
        // await this.updateIsActiveInDb(false);
        await this.actionDeactivateUserOnAzure(payload).then(async (resp: any) => {
          await this.updateIsActiveInDb(false);
        });
      })
      .catch((err: any) => {
        logger.error(err);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  async clickActivate(): Promise<void> {
    logger.log('activate-user');

    this.isSaving = true;

    const userId = await this.actionLoadAzureUserId(this.contactModel.email)
      .then(async (result: any) => {
        const azureUserId = result;
        this.contactAzureId = azureUserId;

        // (AD-0) return logic to `de- + activate` user in `Entra`  // (AD-72) (discussed with Chaslau) Temporary comment Azure activate functionality (just update database) (2023-06)
        // await this.updateIsActiveInDb(true);
        await this.actionActivateUserOnAzure(azureUserId).then(async (resp: any) => {
          await this.updateIsActiveInDb(true);
        });
      })
      .catch((err: any) => {
        logger.error(err);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  async updateIsActiveInDb(isActive: boolean): Promise<void> {
    const payload = {
      id: this.contactModel.recordID,
      isActive: isActive, // `false` means deactivate Contact, `true` activate
      contactAzureId: this.contactAzureId || this.contactModel.contactAzureId, // (AD-282) in case `contactAzureId` is not loaded successfully, use the one from `contactModel` (to avoid EMPTY `contactAzureId` on backend when save `IsActive` false)
    };

    await this.actionDeactivateContact(payload).then(() => {
      this.contactModel.isActive = isActive;
      // If we just deactivated, pass the ID to the close function
      if (!isActive) {
        this.clickClose(+this.contactModel.recordID); 
      } else {
        this.clickClose();
      }
    });
  }

  clickClose(deactivatedId?: number): void {
    this.$emit('click:close', deactivatedId);
  }
}
